import { useQuery } from '@tanstack/react-query';
import { authedClient } from '@/api/trpc';
import useAuth from './useAuth';

const useGetAccountConfig = () => {
  const { user } = useAuth();

  const { data, status, error } = useQuery(
    {
      queryKey: ['getAccountConfig'],
      queryFn: () => authedClient.config.query(),
      enabled: !!user?.accessToken, // Solo ejecutar si hay sesión válida
      retry: false, // No reintentar en caso de error (evita loop de 401)
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
    },
  );

  return [data, status, error] as const;
}

export default useGetAccountConfig;